module.exports = __webpack_public_path__ + "img/reject.9d01bceb.svg";